<template>
  <div class="activity_submit_works_container" :style="{paddingTop: statusBarHeight + 'px'}">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span>提交作品</span>
    </div>
    <div class="activity_submit_works_box">
      <div class="submit_works_label" v-if="!!activity">
        <span>参与活动：</span>
        <span v-text="activity.activityName"></span>
      </div>
      <div class="submit_works_box">
        <div class="submit_works_form_list">
          <div class="submit_works_form_item">
            <div class="submit_works_form_item_title">
              <span class="name">参选作品标题</span>
              <span class="required">*</span>
            </div>
            <div class="submit_works_form_item_body">
              <input class="submit_works_input_text" type="text" placeholder="请输入您的参选作品标题" v-model="workTitle" ref="workTitle" />
            </div>
          </div>
          <div class="submit_works_form_item" v-if="targetType==1">
            <div class="submit_works_form_item_title">
              <span class="name">参选人物头像</span>
              <span class="required">*</span>
              <span class="tips">(仅支持1张，参选头像用于评选)</span>
            </div>
            <div class="submit_works_form_item_body" ref="profile">
              <van-uploader accept="image/*" v-model="profileList" :max-count="1" :after-read="afterProfileRead" :before-delete="deleteProfile"></van-uploader>
            </div>
          </div>
          <div :class="{submit_works_form_item:true,item_no_border:applyForm.length==(index+1)}" v-for="(item,index) in applyForm" :key="index">
            <div class="submit_works_form_item_title" v-if="item.customType==6">
              <van-cell is-link @click="showSingleSelect(item)" v-if="!item.allowNull">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span v-text="item.displayName"></span>
                  <span class="required">*</span>
                </template>
              </van-cell>
              <van-cell is-link :title="item.displayName" @click="showSingleSelect(item)" v-else />
            </div>
            <div class="submit_works_form_item_title" v-else-if="item.customType==8">
              <van-cell is-link @click="showCascadeSelect(item)" v-if="!item.allowNull">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span v-text="item.displayName"></span>
                  <span class="required">*</span>
                </template>
              </van-cell>
              <van-cell is-link :title="item.displayName" @click="showCascadeSelect(item)" />
            </div>
            <div class="submit_works_form_item_title" v-else-if="item.customType==5">
              <span class="name" v-text="item.displayName"></span>
              <span class="required" v-if="!item.allowNull">*</span>
              <span class="tips">
                <span v-if="item.uploadLength>1">(最多上传{{item.uploadLength}}个)</span>
              </span>
            </div>
            <div class="submit_works_form_item_title" v-else>
              <span class="name" v-text="item.displayName"></span>
              <span class="required" v-if="!item.allowNull">*</span>
            </div>
            <!-- 单行文本 -->
            <div class="submit_works_form_item_body" v-if="item.customType==1">
              <input class="submit_works_input_text" type="text" :placeholder="item.help" v-model="item.defualtValue" :maxlength="item.textLength" v-if="item.textLimited" />
              <input class="submit_works_input_text" type="text" :placeholder="item.help" v-model="item.defualtValue" v-else />
            </div>
            <!-- 多行文本 -->
            <div class="submit_works_form_item_body" v-else-if="item.customType==2">
              <textarea class="submit_works_textarea_text" :placeholder="item.help" v-model="item.defualtValue"></textarea>
            </div>
            <!-- 单选按钮 -->
            <div class="submit_works_form_item_body" v-else-if="item.customType==3">
              <div class="radio_list">
                <div :class="{radio:true,checked:option.isDefault==1}" v-for="(option,idx) in item.options" :key="index + '_' + idx" @click="onRadioClick(item.options,option);">
                  <input type="radio" :name="'radioGorup' + item.customId" :checked="option.isDefault==1">
                  <label v-text="option.label"></label>
                </div>
              </div>
            </div>
            <!-- 多选按钮 -->
            <div class="submit_works_form_item_body" v-else-if="item.customType==4">
              <div class="check_list">
                <div :class="{checkbox:true,checked:option.isDefault==1}" v-for="(option,idx) in item.options" :key="index + '_' + idx" @click="onCheckClick(option);">
                  <input type="checkbox" :name="'checkboxGorup' + item.customId" :checked="option.isDefault==1">
                  <label v-text="option.label"></label>
                </div>
              </div>
            </div>
            <!-- 附件上传 上传文件的类型:1.视频2.音频3.图片，该字段为空时表示不限制 -->
            <div class="submit_works_form_item_body" v-else-if="item.customType==5">
              <upload :data="item" :index="index" @uploadData="resourceIdList"></upload>
            </div>
            <!-- 下拉列表 -->
            <div class="submit_works_form_item_body" v-else-if="item.customType==6" @click="showSingleSelect(item)">
              <input class="submit_works_input_text" type="text" v-model="item.defualtValue" :placeholder="item.help" disabled />
            </div>
            <!-- 二级下拉 -->
            <div class="submit_works_form_item_body" v-else-if="item.customType==8" @click="showCascadeSelect(item)">
              <input class="submit_works_input_text" type="text" v-model="item.defualtValue" :placeholder="item.help" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="operate_box">
      <span class="operate_btn" @click="submitWorks">提交作品</span>
    </div>
    <van-popup v-model="item.showPicker" round position="bottom" v-for="(item,index) in applyForm" :key="index">
      <van-picker show-toolbar :title="item.help" :columns="item.options" value-key="label" @cancel="item.showPicker = false" @confirm="onSingleSelectConfirm" v-if="item.customType==6" />
      <van-picker show-toolbar :title="item.help" :columns="item.options" value-key="label" @cancel="item.showPicker = false" @confirm="onCascadeSelectConfirm" v-else-if="item.customType==8" />
    </van-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import activityApi from "@/api/apis/activity.js";
import UploadServer from "@/api/apis/upload.js";
import upload from "./components/Upload";
export default {
  name: "SubmitWorks",
  data() {
    return {
      params: {
        contentType: 1,
        activityId: null,
        cId: 0,
      },
      activity: null, // 活动详情
      targetType: null, // 参选类型：1,人物;2,作品
      applyForm: null, // 参赛作品自定义表单
      modelId: null, // 自定义参选表单ID
      workTitle: "", // 参选作品标题
      profileList: [], // 人物头像列表
      profileResourceIdList: [], // 上传的人物头像 resourceId 列表
      curItem: null, // 当前选中的下拉项
      pageData: {
        title: "",
        info: "",
        shareUrl: "",
        imageUrl: ""
      },
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "shareRootUrl", "statusBarHeight"]),
  },
  components: {
    upload,
  },
  methods: {
    /* 获取活动详情 */
    getActivityDetail() {
      var _this = this;
      activityApi
        .getActivityDetail(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            _this.activity = res.data;
            _this.pageData.title = _this.activity.activityName;
            var desc = _this.activity.description;
            if (!desc || desc.length == 0) {
              desc = _this.activity.activityName;
            }
            _this.pageData.info = desc;
            _this.pageData.imageUrl = _this.activity.sharePictureUrl;
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取参赛作品自定义表单 */
    getApplyFormModelByActivityId() {
      var _this = this;
      activityApi
        .getApplyFormModelByActivityId(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            _this.modelId = res.data.modelId;
            _this.targetType = res.data.targetType;
            let list = res.data.custom;
            for (var i = 0; i < list.length; i++) {
              list[i].options = JSON.parse(list[i].options);
              if (list[i].customType == 6) {
                list[i].showPicker = false;
              } else if (list[i].customType == 8) {
                list[i].showPicker = false;
                var ops = list[i].options;
                var array = [];
                for (var j = 0; j < ops.length; j++) {
                  var childArray = [];
                  for (var k = 0; k < ops[j].relativeChildren.length; k++) {
                    childArray.push({
                      label: ops[j].relativeChildren[k].relatedOption,
                    });
                  }
                  array.push({
                    label: ops[j].relatedTitle,
                    children: childArray,
                  });
                }
                list[i].options = array;
              }
            }
            _this.applyForm = list;
          } else {
            console.log(res.message);
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 单选框组，选择操作 */
    onRadioClick(options, option) {
      if (option.isDefault == 0) {
        option.isDefault = 1;
        for (var i = 0; i < options.length; i++) {
          if (option.label != options[i].label) {
            options[i].isDefault = 0;
          }
        }
      }
    },
    /* 多选框组，选择操作 */
    onCheckClick(option) {
      if (option.isDefault == 0) {
        option.isDefault = 1;
      } else {
        option.isDefault = 0;
      }
    },
    /* 上传人物头像 自行将文件上传至服务器 */
    afterProfileRead(file) {
      var _this = this;
      file.status = "uploading";
      file.message = "上传中...";

      UploadServer.fetchUploadPic(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.profileResourceIdList.push(res.resourceId);
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 移除人物头像 */
    deleteProfile(file) {
      var index = this.profileResourceIdList.indexOf(file.id);
      if (index > -1) {
        this.profileResourceIdList.splice(index, 1);
      }
      return (file, name) => {
        let fileIndex = name.index;
        this.profileList[file].splice(fileIndex, 1);
      };
    },
    /* 显示下拉选择 */
    showSingleSelect(item) {
      this.curItem = item;
      item.showPicker = true;
    },
    /* 下拉选择 点击确认 */
    onSingleSelectConfirm(value) {
      this.curItem.defualtValue = value.label;
      this.curItem.showPicker = false;
    },
    /* 显示级联选择 */
    showCascadeSelect(item) {
      this.curItem = item;
      item.showPicker = true;
    },
    /* 级联选择 点击确认 */
    onCascadeSelectConfirm(value, index) {
      this.curItem.defualtValue = value.join(",");
      this.curItem.showPicker = false;
    },
    resourceIdList(data) {
      this.applyForm[data.index].defualtValue = data.list.join(",");
    },
    /* 提交作品 */
    submitWorks() {
      var _this = this;

      if (!_this.userInfo) {
        _this.$toast({
          message: "请先登录！",
          position: "center",
        });
        return;
      }

      if (_this.workTitle.length == 0) {
        _this.$toast({
          message: "请填写参选作品标题！",
          position: "center",
        });
        _this.$nextTick((x) => {
          _this.$refs.workTitle.focus();
        });
        return;
      }

      if (_this.targetType == 1 && _this.profileResourceIdList.length == 0) {
        _this.$toast({
          message: "请上传参选人物头像！",
          position: "center",
        });
        return;
      }

      var valueList = [];
      if (!!_this.applyForm && _this.applyForm.length > 0) {
        for (var i = 0; i < _this.applyForm.length; i++) {
          var item = _this.applyForm[i];
          var cdata = {};
          cdata.customUUID = item.customUUID;
          cdata.type = item.customType;
          // 单行文本 多行文本 下拉 级联下拉
          if (cdata.type == 1 || cdata.type == 2 || cdata.type == 5 || cdata.type == 6 || cdata.type == 8) {
            cdata.value = item.defualtValue;
          }
          // 单选
          else if (cdata.type == 3) {
            for (var j = 0; j < item.options.length; j++) {
              if (item.options[j].isDefault == 1) {
                cdata.value = item.options[j].label;
                break;
              }
            }
          }
          // 多选
          else if (cdata.type == 4) {
            var value = new Array();
            for (var j = 0; j < item.options.length; j++) {
              if (item.options[j].isDefault == 1) {
                value.push(item.options[j].label);
              }
            }
            if (value.length == 0) {
              cdata.value = "";
            } else {
              cdata.value = JSON.stringify(value);
            }
          }

          var required = item.allowNull == 0 ? true : false;
          if ((cdata.type == 1 || cdata.type == 2) && required && cdata.value == "") {
            _this.$toast({
              message: item.displayName + "不能为空，请填正确填写！",
              position: "center",
            });
            return;
          }

          if (cdata.type == 5 && required && cdata.value == "") {
            _this.$toast({
              message: item.displayName + "为必传项，请选择文件进行上传！",
              position: "center",
            });
            return;
          }

          if ((cdata.type == 3 || cdata.type == 4 || cdata.type == 6 || cdata.type == 8) && required && cdata.value == "") {
            _this.$toast({
              message: item.displayName + "为必选，请选择！",
              position: "center",
            });
            return;
          }
          valueList.push(cdata);
        }
      }

      var params = {
        activityId: _this.params.activityId,
        memberId: _this.userInfo.id,
        title: _this.workTitle, //标题
        autoApprove: 0, //是否自动审核 0-否，1-是
        fake: null, // null或是0是普通的活动, 1-给联盟活动中导入的报名人添加作品
        // isLocked: 0, // 是否锁定 0-否，1-是
        modelId: _this.modelId, // 自定义参选表单Id
        valueList: JSON.stringify(valueList), //
        profile: _this.profileResourceIdList.length > 0 ? _this.profileResourceIdList[0] : 0, //头像
      };
      activityApi
        .addApplyForm(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.$dialog
              .alert({ message: "作品提交成功，待审核后可进行展示！" })
              .then(() => {
                _this.$router.push({
                  path: "/activity_detail",
                  query: {
                    activityId: _this.params.activityId,
                  },
                });
              });
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    document.title = "上传作品";
    var _this = this;
    let query = _this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "activityId")) {
      _this.params.activityId = Number(query.activityId);
      _this.getActivityDetail();
      _this.getApplyFormModelByActivityId(); //获取参赛作品自定义表单

      _this.pageData.shareUrl = _this.shareRootUrl + "index_share?contentType=" + _this.params.contentType + "&activityId=" + _this.params.activityId + "&contentCode=" + _this.nodeCode;
      // 提供给客户端调用，设置分享信息
      _this.$bridge.registerhandler("getShareInfo", function () {
        // 调用客户端方法，将分享信息传给客户端
        _this.$bridge.callhandler("setShareInfo", JSON.stringify(_this.pageData), function (res) { });
      });

      loadStat(); // 友盟统计
    } else {
      _this.$router.replace({
        path: "/error",
      });
    }
    UploadServer.startUpload();
  },
  destroyed() {
    UploadServer.stopUpload();
  }
};
</script>
<style scoped lang="scss">
.activity_submit_works_container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  .activity_submit_works_box {
    position: relative;
    width: 100%;
    height: calc(100% - 90px);
    background-color: #f6f6f6;
    .submit_works_label {
      padding: 5px 15px;
      line-height: 26px;
      background-color: #ecf3ff;
      color: #222;
      font-size: 12px;
    }
    .submit_works_box {
      position: relative;
      width: 100%;
      max-height: calc(100% - 31px);
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      .submit_works_form_list {
        padding: 5px 15px;
        .submit_works_form_item {
          border-bottom: 1px solid #ececec;
          &.item_no_border {
            border: none;
          }
          .submit_works_form_item_title {
            line-height: 36px;
            color: #333;
            font-size: 18px;
            .name {
              font-size: 18px;
            }
            .required {
              margin-left: 5px;
              color: red;
            }
            .tips {
              margin-left: 5px;
              font-size: 14px;
            }
            .van-cell {
              line-height: 36px;
              padding: 0;
              background-color: #fff;
              color: #333;
              font-size: 18px;
              &:hover,
              &:active {
                background-color: #fff;
              }
              .van-icon.van-cell__right-icon {
                height: 36px;
                line-height: 36px;
              }
            }
          }
          .submit_works_form_item_body {
            .submit_works_input_text {
              color: #333;
              width: 100%;
              padding: 5px 0px;
              margin-bottom: 10px;
              // background: #f7f8fa;
              border: none;
              &:disabled {
                background: none;
              }
            }
            .submit_works_textarea_text {
              color: #333;
              width: 100%;
              height: 240px;
              line-height: 24px;
              padding: 5px 0px;
              margin-bottom: 5px;
              // background: #f7f8fa;
              border: none;
              resize: none;
            }
            .radio_list {
              margin-bottom: 10px;
              .radio {
                line-height: 24px;
                padding: 8px 10px;
                border: 2px solid #ececec;
                border-radius: 5px;
                margin-bottom: 15px;
                &.checked {
                  border-color: #397ef5;
                }
                label {
                  margin-left: 5px;
                }
              }
            }
            .check_list {
              margin-bottom: 10px;
              .checkbox {
                line-height: 24px;
                padding: 8px 10px;
                border: 2px solid #ececec;
                border-radius: 5px;
                margin-bottom: 15px;
                &.checked {
                  border-color: #397ef5;
                }
                label {
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 45px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .operate_btn {
      flex: 1;
      height: 45px;
      line-height: 45px;
      background-color: #397ef5;
      text-align: center;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>